<template>
    <a-popover
        :visible="!readOnly && open"
        :overlayClassName="'no-padding archive-filter'"
        placement="bottom"
        @visibleChange="(isVisible) => (open = isVisible)"
        trigger="click"
    >
        <div slot="content">
            <div class="filter-wrapper-form">
                <div class="filter-wrapper-form-title">
                    <span class="material-icons closeIcon" @click="close"> close </span>
                    <span class="material-icons filterIcon"> {{ icon }} </span>
                    <span class="filterName ml-2">{{ filterMetas[clone.name].title || clone.name }}</span>
                </div>
                <div
                    class="w-100 mb-3 row"
                    v-if="
                        ['email', 'fullname', 'country', 'city', 'os', 'visitingPage', 'browser'].includes(clone.name)
                    "
                >
                    <div style="width: 100%" class="row mx-2 mb-2" v-for="(rule, index) of ruleList" :key="rule.id">
                        <span class="col-md-1">
                            <input
                                type="checkbox"
                                :id="rule.label"
                                :checked="clone.rule === rule.id"
                                @click="clone.rule = rule.id"
                            />
                        </span>
                        <span class="col-md-10 d-flex flex-column">
                            <label :for="rule.label">{{ rule.label }}</label>
                            <a-input v-if="clone.rule === rule.id" class="row select-input" v-model="clone.value" />
                        </span>
                    </div>
                </div>
                <div class="w-100" v-if="['firstSeen', 'lastSeen', 'connectionTime'].includes(clone.name)">
                    <a-select
                        :value="clone.value"
                        @select="handleSelect($event, 'option')"
                        class="select-story"
                        :placeholder="$t('chatbotv2.wholeTimeSpan')"
                        :filter-option="false"
                    >
                        <a-select-option v-for="period of periods" :value="period.value" :key="period.value">
                            <span class="blockTypeText">{{ $t(`chatbotv2.time.${period.value}`) }}</span>
                        </a-select-option>
                    </a-select>
                </div>
                <div class="w-100" v-if="['tags'].includes(clone.name)">
                    <a-select
                        :value="tagName"
                        @select="handleSelect($event, 'tag')"
                        class="select-story"
                        :filter-option="false"
                    >
                        <a-select-option v-for="tag of tags" :value="tag._id + ' ' + tag.name" :key="tag._id">
                            <span class="blockTypeText">{{ tag.name }}</span>
                        </a-select-option>
                    </a-select>
                </div>
                <div style="margin-top: 20px; width: 100%" class="w-100">
                    <a-button type="primary" class="d-block w-100" :disabled="!isChanged()" @click="saveValue"
                        >{{ $t("chatbotv2.applyFilter") }}
                    </a-button>
                </div>
            </div>
        </div>

        <div class="filter-wrapper-preview">
            <span class="material-icons mainIcon"> {{ icon }} </span>
            <span class="material-icons closeIcon" @click="remove"> close </span>
            <span text-truncate="" text-actions="">
                <span text-weight="semi-bold"></span>
                <span>{{ getFilterLabel() }}</span>
            </span>
        </div>
    </a-popover>
</template>

<script>
import _ from "lodash";
import log2 from "../../../utils/log2";
import { mapState, mapMutations, mapActions } from "vuex";

const log = log2("MiniFilterPreview");
export default {
    name: "VisitorMiniFilterPreview",
    props: {
        value: {
            required: true,
            type: Object,
        },
        icon: {
            type: String,
            required: true,
        },
        onRemoved: {
            type: Function,
            required: true,
        },
        defaultOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
        autoRemoveWhenCancel: {
            type: Boolean,
            required: false,
            default: false,
        },
        readOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            ruleList: [
                {
                    label: "is",
                    id: "is",
                },
                {
                    label: "is not",
                    id: "isNot",
                },
                {
                    label: "contains",
                    id: "contains",
                },
                {
                    label: "starts with",
                    id: "startsWith",
                },
                {
                    label: "ends with",
                    id: "endsWith",
                },
            ],
            open: this.defaultOpen,
            clone: _.cloneDeep(this.value),
            periods: [
                { value: "today", label: this.$t("time.today") },
                { value: "yesterday", label: this.$t("time.yesterday") },
                { value: "last7", label: this.$t("time.last7") },
                { value: "last30", label: this.$t("auto.timeLast30") },
                { value: "this-month", label: this.$t("time.currentMonth") },
                { value: "last-month", label: this.$t("time.lastMonth") },
                { value: "last-3-month", label: this.$t("time.last3Months") },
                { value: "this-year", label: this.$t("time.thisYear") },
                { value: "last-year", label: this.$t("time.lastYear") },
            ],
            integrations: [
                { value: "web", name: "Supsis Widget" },
                { value: "whatsapp", name: "WhatsApp" },
            ],
            filterList: [],
            filterMetas: {
                fullname: { icon: "person", title: "Name" },
                email: { icon: "alternate_email", title: this.$t("message.email") },
                lastSeen: { icon: "date_range", title: this.$t("chatbotv2.lastSeen") },
                firstSeen: { icon: "date_range", title: this.$t("auto.firstSeenFieldTitle") },
                country: { icon: "location_on", title: this.$t("message.country") },
                city: { icon: "location_on", title: this.$t("message.city") },
                os: { icon: "location_on", title: this.$t("message.os") },
                connectionTime: { icon: "settings_suggest", title: this.$t("message.connectionDate") },
                visitingPage: { icon: "date_range", title: this.$t("message.connectionDate") },
                browser: { icon: "public", title: this.$t("message.visitingPage") },
                tags: { icon: "ads_click", title: this.$t("visitor.tags") },
                visitorId: { icon: "filter_alt", title: "Visitor ID" },
            },
            tagName: "",
        };
    },
    methods: {
        ...mapActions({
            getTags: "tag/getTags",
        }),
        getFilterLabel() {
            let { name, value, rule } = this.clone;
            console.log("name, value, rule", { name, value, rule });
            if (!!this.filterMetas[name]) {
                value = name === "firstSeen" ? this.periods.find((period) => period.value === value).label : value;
                value = name === "lastSeen" ? this.periods.find((period) => period.value === value).label : value;
                if (name === "tags") {
                    return `${this.filterMetas[name].title} ${rule} ${this.tagName}`;
                } else return `${this.filterMetas[name].title} ${rule} ${value}`;
            } else {
                return `${name} ${rule} ${value}`;
            }
        },
        remove(e) {
            e.stopPropagation();
            e.preventDefault();
            this.onRemoved();
        },
        saveValue() {
            log("saveValue", this.clone);
            this.$emit("save", this.clone);
            this.open = false;
        },
        handleSelect(value, type) {
            if (type === "tag") {
                this.tagName = value.split(" ")[1];
                this.clone.value = value.split(" ")[0];
            } else this.clone.value = value;
        },
        isChanged() {
            return this.defaultOpen || !_.isEqual(this.value, this.clone);
        },
        close() {
            this.open = false;
            if (this.autoRemoveWhenCancel) {
                this.onRemoved();
            }
        },
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            tags: (state) => state.tag.tags.data,
        }),
    },
    mounted() {
        if (this.type === "lastSeen" && this.type === "firstSeen") {
            this.clone.value = "today";
        }
        this.getTags();
    },
    watch: {
        defaultOpen(newVal) {
            this.open = newVal;
        },
        value: {
            handler(newVal) {
                this.clone = _.cloneDeep(newVal);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.filter-wrapper-form {
    align-items: flex-start;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    min-width: 325px;
    padding: 20px;
    position: relative;
    text-align: left;

    .filter-wrapper-form-title {
        align-items: center;
        cursor: default;
        display: flex;
        margin-bottom: 20px;
        width: 100%;

        .closeIcon {
            color: #008aff;
            cursor: pointer;
            font-size: 19px;
            position: absolute;
            right: 20px;
            top: 20px;
            transition: all 0.3s;
        }

        .filterIcon {
            color: #006cff;
            font-size: 16px;
            margin-right: 10px;
            position: relative;
            top: 1px;
        }

        .filterName {
            color: #22272d;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }
    }
}

.archive-filter {
    .ant-popover-inner-content {
        width: 350px;
    }

    .select-story {
        width: 100%;

        &.ant-select-open {
            .blockTypeText {
                color: #000 !important;
            }
        }
    }
}
</style>
<style scoped lang="scss">
.select-input {
    height: 37px;
    border-radius: 6px;
}

.filter-wrapper-preview {
    align-items: center;
    background: #2c3f84;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    height: 32px;
    padding: 10px;
    transition: all 0.3s;
    white-space: nowrap;
    width: max-content;
    margin-right: 5px;

    [text-truncate] {
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    [text-actions] {
        cursor: pointer;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
    }

    &:hover {
        opacity: 0.8 !important;

        .material-icons {
            &.mainIcon {
                display: none;
            }

            &.closeIcon {
                display: inherit;
            }
        }
    }

    .material-icons {
        font-size: 15px;
        margin-right: 10px;

        &.mainIcon {
            display: inherit;
        }

        &.closeIcon {
            display: none;
        }
    }
}
</style>
